// import React from 'react'

// const ViewHistory = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewHistory


import * as React from "react";
import { useState, useEffect, useContext, useCallback } from "react";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { ViewInitiatorHistoryGrnData } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import { externalgetApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import { GRN_API_02, GRN_API_02_2,GRN_API_10 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE, CON_YES } from "../../utils/sys/Constants";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { FormatDate } from "../../utils/common/DateUtils";
import { AnyForNow, GrnFilterState } from "./types";
import PrintIcon from '@mui/icons-material/Print';
import MailIcon from '@mui/icons-material/Mail';
import { SEARCH_FIELDS_GRNHISTORY } from "../../utils/sys/GrnSearchFeilds";
import FilterSecrchByID from "../../components/grn/FilterSecrchByID";
import { BUTTON_LABELS, GRN_BREADCRUMBS, PAGE_TITLES } from "../../utils/sys/GrnLabels";
import { GRN_ROUTES, RELATED_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  createInitialFilters,
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";
import {
  GRN_HISTORY,
  GRN_HISTORY_FILTER,
  GRN_STORAGE_KEYS,
  PARAM_ID,
} from "../../utils/sys/GrnConstants";

const ViewHistory: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [allData, setAllData] = useState<AnyForNow[]>([]);
  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});
  const shouldIncludeAll = moduleParamJsonArray.some(
    (item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW && item.PARAVALUE === CON_YES
  );
  const warehouseOptions = useWarehouseOptions(COMPCODE);
  const visibleStatuses = GRN_HISTORY_FILTER.VISIBLE_STATUSES as readonly string[];
   const visibleStatuses_flow2 = GRN_HISTORY_FILTER.VISIBLE_STATUSES_FLOW2 as readonly string[];


  const statusFilter = useCallback(
    (item: AnyForNow) => {
      if (String(item.trcatcode) !== GRN_HISTORY_FILTER.TRCATCODE) {
        return false;
      }
      if (shouldIncludeAll) {
        return visibleStatuses.includes(String(item.trsts));
      }
       return visibleStatuses_flow2.includes(String(item.trsts));
    },
    [shouldIncludeAll, visibleStatuses]
  );
  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: statusFilter,
    deps: [statusFilter],
  });
  const [filters, setFilters] = useState<GrnFilterState>(createInitialFilters());
  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.GRN_MANAGEMENT,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);

  const handleItemClick = (grncode: string, trsts: string,trcatcode:string, ponumber: string, actionText: string): void => {
    if (actionText === BUTTON_LABELS.VIEW) {
      navigate(GRN_ROUTES.View_TEP_HISTORY, {
        state: { grncode, trsts,trcatcode, origin: GRN_HISTORY.ORIGIN },
      });
    } else if (actionText === BUTTON_LABELS.VIEW_HISTORY) {
      navigate(GRN_ROUTES.View_TEP_HISTORY, { state: { grncode, trsts, ponumber } });
    }else if (actionText === BUTTON_LABELS.EDIT) {
      navigate(GRN_ROUTES.EDIT, { state: { grncode, trsts, ponumber } });
    } else if (actionText === BUTTON_LABELS.PRINT || actionText === "Print") {
      navigate(GRN_ROUTES.VIEW_GRN_NOTES, { state: { grncode, trsts, ponumber,origin: GRN_HISTORY.ORIGIN } });
    }
  };

  // Refs to prevent duplicate API calls
  const hasFetchedGrnListRef = React.useRef(false);
  const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const isInitialLoadRef = React.useRef(true);

  // Update ref when grnStatusTypes changes
  React.useEffect(() => {
    grnStatusTypesRef.current = grnStatusTypes;
  }, [grnStatusTypes]);

  const fetchSupplierListData = React.useCallback(async (): Promise<void> => {
    if (!COMPCODE || !STAFFMAPLOCODE) {
      return;
    }

    // Prevent duplicate calls
    if (hasFetchedGrnListRef.current) {
      return;
    }

    try {
      hasFetchedGrnListRef.current = true;
      setLoading(true);

      const result = await externalgetApi(GRN_API_02_2, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
      });

      if (!Array.isArray(result)) {
        setAllData([]);
        setFilteredRows([]);
        setLoading(false);
        return;
      }

      const shouldIncludeAll =
        moduleParamJsonArray.filter((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)[0]
          ?.PARAVALUE === CON_YES;

      const filteredResult = result.filter((item) => {
        if (shouldIncludeAll) {
          return visibleStatuses.includes(String(item.trsts));
        } else {
          return visibleStatuses.includes(String(item.trsts));
        }
      });
      console.log("Filtered Result", filteredResult);

      const rowsWithId = filteredResult.map((item, index) => {
        const matchedStatus = grnStatusTypesRef.current.find(
          (status) => String(status.trsts) === String(item.trsts)
        );
        return {
          ...item,
          id: item.grncode || index,
          invoicedate: FormatDate(item.invoicedate) || null,
          endate: FormatDate(item.endate) || null,
          podate: FormatDate(item.podate) || null,
          statusLabel: matchedStatus?.trenuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
          statusColor:
            matchedStatus?.colorcode || GRN_HISTORY_FILTER.STATUS_FALLBACK_COLOR,
          invoicedateRaw: item.invoicedate,
          endateRaw: item.endate,
          ponumber: item.ponumber || "-",
          grnstatuscode: item.trsts,
           Supplier: `${item.suprefcode} - ${item.suppliername}`,
        };
      });

      setAllData(rowsWithId);
      setFilteredRows(rowsWithId);
    } catch (err) {
      console.error("Error fetching supplier list data:", err);
      hasFetchedGrnListRef.current = false; // Reset on error to allow retry
    } finally {
      setLoading(false);
    }
  }, [COMPCODE, STAFFMAPLOCODE, moduleParamJsonArray]);

  // Initial load - only fetch when status types are loaded
  useEffect(() => {
    if (grnStatusTypes.length > 0 && isInitialLoadRef.current && COMPCODE && STAFFMAPLOCODE) {
      isInitialLoadRef.current = false;
      fetchSupplierListData();
    }
  }, [fetchSupplierListData, grnStatusTypes.length, COMPCODE, STAFFMAPLOCODE]);

  useEffect(() => {
    if (!allData.length) {
      setFilteredRows([]);
      return;
    }

    let filtered = allData;

    // Common search across all relevant fields
    if (filters.searchValue) {
      const search = filters.searchValue.toLowerCase();
      filtered = filtered.filter((item) =>
        [
          item.grncode,
          item.ponumber,
          item.suprefcode,
          item.suppliername,
          item.invoiceno
        ]
          .map(field => field?.toString().toLowerCase())
          .some(val => val && val.includes(search))
      );
    }
    if (filters.warehouse) {
      filtered = filtered.filter(
        (item) => String(item.restcode) === filters.warehouse
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (item) => String(item.grnstatuscode) === String(filters.status)
      );
    }

    // if (filters.fromDate) {
    //   filtered = filtered.filter(
    //     (item) => new Date(item.invoicedate) >= new Date(filters.fromDate)
    //   );
    // }

    // if (filters.toDate) {
    //   filtered = filtered.filter(
    //     (item) => new Date(item.endate) <= new Date(filters.toDate)
    //   );
    // }
  if (filters.fromDate && filters.toDate) {
  const from = new Date(filters.fromDate);
  const to = new Date(filters.toDate);

  const start = from < to ? from : to;
  const end = from < to ? to : from;

  filtered = filtered.filter(
    (item) => {
      const date = new Date(item.invoicedateRaw || item.endateRaw);
      return date >= start && date <= end;
    }
  );
} else if (filters.fromDate) {
  const from = new Date(filters.fromDate);
  filtered = filtered.filter(
    (item) => new Date(item.invoicedateRaw) >= from
  );
} else if (filters.toDate) {
  const to = new Date(filters.toDate);
  filtered = filtered.filter(
    (item) => new Date(item.endateRaw) <= to
  );
}


    setFilteredRows(filtered);
  }, [filters, allData]);

  console.log("Filtered Rows", filteredRows); 

  const handleFilterChange = (newFilters: GrnFilterState): void => {
    setFilters(newFilters);
  };
  const menuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) =>
        handleItemClick(row.grncode, row.trsts,row.trcatcode, row.ponumber, BUTTON_LABELS.VIEW),
    },
    //  {
    //   text: BUTTON_LABELS.VIEW_HISTORY,
    //   icon: <VisibilityOutlinedIcon />,
    //   onClick: (row: AnyForNow) =>
    //     handleItemClick(row.grncode, row.trsts, row.ponumber, BUTTON_LABELS.VIEW_HISTORY),
    // },
    {
      text: "Email",
      icon: <MailIcon />,
      onClick: (row: AnyForNow) => handleItemClick(row.grncode, row.trsts,row.trcatcode,  row.ponumber, "Print"),
    },
    {
      text: "Print",
      icon: <PrintIcon />,
      onClick: (row: AnyForNow) => handleItemClick(row.grncode, row.trsts, row.trcatcode,  row.ponumber, "Print"),
    },
    // {
    //   text: BUTTON_LABELS.EDIT,
    //   icon: <ModeEditOutlineOutlinedIcon />,
    //   onClick: (row) =>
    //     handleItemClick(row.grncode, row.trsts, row.ponumber, BUTTON_LABELS.EDIT),
    //   disabled: (row) => row.trsts !== "1",
    // },
  ];

  const toCreateGrn = (): void => {
    localStorage.removeItem(GRN_STORAGE_KEYS.GRN_PAGE_DATA);
    navigate(GRN_ROUTES.CREATE);
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.MANAGEMENT}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
         
            aria-current="page"
          >
            {GRN_BREADCRUMBS.GRN_HISTORY}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewInitiatorHistoryGrnData.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
              <Box
                sx={{
                  gap: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {/* <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                >
                  View
                </Button> */}
                {/* <Button
                  variant="contained"
                  startIcon={<AddCircleOutlineIcon />}
                  size="medium"
                  // sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                  sx={{ ...styles.btn_primary }}
                  onClick={toCreateGrn}
                >
                  Create
                </Button> */}
              </Box>
            </Grid>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
        {/* <FilterGrnSearch /> */}
       <FilterSecrchByID
                 warehouseOptions={warehouseOptions}
                grnStatusTypes={grnStatusTypes}
                onFilterChange={handleFilterChange}
                  searchFields={SEARCH_FIELDS_GRNHISTORY}
      
              />

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={ViewInitiatorHistoryGrnData.columns}
            rows={filteredRows}
            // statusOptions={statusOptions}
            menuItems={menuItems}
            tabletitle={ViewInitiatorHistoryGrnData.name}
            gridid={GRN_HISTORY_FILTER.GRID_ID}
            sx={styles.view_data_grid_page}
            grnStatusTypes={grnStatusTypes}
            onSelectionChange={undefined}
            grnReturnStatusTypes={undefined}
            selectionModel={undefined}
            loading={loading}
            showCheckbox={false}
          />
        </Box>
      </Box>
    </>
  );
};

export default ViewHistory;
